<div class="error">
  <div class="message">
    <div class="content">
      {{ message }}
    </div>
  </div>
</div>
<safety-message-download></safety-message-download>
